import { useSelector } from "react-redux";
import { Typography, Box, Stack } from "@mui/material";
import { useLocation } from "react-router-dom";
import { Jdate } from "../../utility/utils";

const Footer = ({ styles }) => {
  const config = useSelector((state) => state.config);
  const { search } = useLocation();
  let query = new URLSearchParams(search);

  return (
    <>
      <Box
        className={styles}
        sx={{
          width: "100%",
          // height: "200px",
          bgcolor: "primary.main",
          display: { xs: "none", md: "flex" },
          alignItems: "center",
          justifyContent: "space-evenly",
          flexDirection: "column",
        }}
      >
        <Typography variant="p" color="#fff">
          تمام حقوق این وب سایت برای {config.PanelName} محفوظ می باشد (
          {Jdate(null, false, true, "YYYY")})
        </Typography>
      </Box>
    </>
  );
};

export default Footer;
